/* src/app/forms/formview/edit-form-multi-table/edit-form-multi-table.component.scss */
.header-line {
  display: grid;
  width: 100%;
  height: 100%;
  max-height: 40px;
  overflow: hidden;
  padding-left: 5px;
  padding-right: 20px;
  background: var(--tem-surface-2);
  border: 1px solid var(--tem-border);
  border-radius: var(--tem-radius) var(--tem-radius) 0 0;
  align-items: center;
}
.multi-grid {
  display: grid;
  align-items: center;
  gap: 15px;
}
.header {
  font-size: 90%;
  font-weight: 600;
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
  width: 100%;
  text-align: center;
  width: 124px;
  max-width: 124px;
  max-height: 50px;
}
.action-image-buttons {
  font-size: 80%;
  bottom: 0;
  width: 100%;
}
.no-data {
  display: flex;
  height: 100%;
  align-items: center;
  flex-direction: column;
}
.data-text {
  font-size: 100%;
  font-weight: 200;
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
  text-align: center;
  width: 100%;
  width: 124px;
  max-width: 124px;
  max-height: 40px;
}
.data-int {
  font-size: 100%;
  font-weight: 200;
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
  text-align: center;
  width: 100%;
  width: 124px;
  max-width: 124px;
  max-height: 40px;
}
.data-float {
  font-size: 100%;
  font-weight: 200;
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
  text-align: center;
  width: 100%;
  width: 124px;
  max-width: 124px;
  max-height: 40px;
}
.data-date {
  font-size: 100%;
  font-weight: 200;
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
  text-align: center;
  width: 100%;
  width: 124px;
  max-width: 124px;
  max-height: 40px;
}
.variation-grid {
  width: 100%;
  height: 100%;
  overflow: auto;
  position: relative;
  padding-right: 12px;
  margin-bottom: 4px;
}
.variation-grid .border {
  border-top: 1px solid var(--tem-border);
}
.lines {
  display: grid;
  height: 40px;
  overflow: hidden;
  border-bottom: 1px solid var(--tem-border);
  padding-left: 5px;
  padding-right: 5px;
}
.lines:hover {
  background: var(--tem-accent-soft);
}
.checkbox-col {
  height: 100%;
  display: flex;
  align-items: center;
}
.table-multi {
  display: flex;
  flex-direction: column;
  height: 100%;
  overflow: auto;
}
:host {
  height: 100%;
}
.button-table-action {
  display: flex;
  flex-direction: row;
  align-items: center;
  background-color: var(--tem-surface-2);
  border-radius: var(--tem-radius);
  padding: 4px;
  justify-content: flex-start;
}
.flex-spacer {
  flex-grow: 1;
}
.button-table-action button {
  padding: 0 15px;
  font-size: 0.8em;
  line-height: 24px !important;
}
.info {
  text-align: center;
  font-weight: 500;
  align-self: center;
  margin-right: 6px;
}
.info.data {
  border-radius: 16px;
  padding: 5px 10px;
  font-size: 80%;
  border: 1px solid var(--tem-border);
  background: var(--tem-surface);
  color: var(--tem-ink);
}
.hdivider {
  margin: 4px 0;
}
.multi-content {
  display: flex;
  flex-direction: column;
  height: 100%;
}
/*# sourceMappingURL=edit-form-multi-table.component.css.map */
